/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  DefinePriorityFamiliesResponse,
  FamilyDto
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getFamilies = () => {
/**
 * Returns the list of product families available for diagnosis in the specified store
 * and team context. Each family includes its translated name and a priority flag
 * indicating whether it requires attention based on sales performance and previous
 * compliance scores. Priority families are recommended for diagnosis first.
 * @summary Get families available for a store/team
 */
const findFamilies = (
    storeId: number,
    teamId: number,
 ) => {
      return customInstance<FamilyDto[]>(
      {url: `/api/v1/stores/${storeId}/teams/${teamId}/families`, method: 'GET'
    },
      );
    }
  /**
 * Triggers the batch computation of priority families for all stores. This endpoint
 * analyzes sales data from Perfeco and historical compliance scores to determine
 * which product families should be flagged as priorities for each store/team. Typically
 * invoked by a scheduled job but can be called manually for testing. Returns any
 * errors encountered during processing.
 * @summary Trigger computation of priority families (scheduled job endpoint)
 */
const generatePriorityFamilies = (

 ) => {
      return customInstance<DefinePriorityFamiliesResponse>(
      {url: `/api/v1/top_families/generate`, method: 'POST'
    },
      );
    }
  return {findFamilies,generatePriorityFamilies}};
export type FindFamiliesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getFamilies>['findFamilies']>>>
export type GeneratePriorityFamiliesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getFamilies>['generatePriorityFamilies']>>>
